var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _circle3, _path6, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidateSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.3115C0 20.1024 1.79086 18.3115 4 18.3115H11.6213C13.8305 18.3115 15.6213 20.1024 15.6213 22.3115V24.3845C15.6213 24.9368 15.1736 25.3845 14.6213 25.3845H1C0.447715 25.3845 0 24.9368 0 24.3845V22.3115Z",
    fill: "#307F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7773 22.3115C43.7773 20.1024 45.5682 18.3115 47.7773 18.3115H55.3987C57.6078 18.3115 59.3987 20.1024 59.3987 22.3115V24.3845C59.3987 24.9368 58.951 25.3845 58.3987 25.3845H44.7773C44.2251 25.3845 43.7773 24.9368 43.7773 24.3845V22.3115Z",
    fill: "#307F92"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.96226,
    cy: 12.2152,
    r: 4.53453,
    fill: "#307F92"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.7406,
    cy: 12.2152,
    r: 4.53453,
    fill: "#307F92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1602 0C38.3626 7.52504e-05 45.8231 7.57664 45.8232 16.9229C45.8232 26.2692 38.3627 33.8466 29.1602 33.8467C19.9576 33.8467 12.4971 26.2692 12.4971 16.9229C12.4972 7.57659 19.9577 0 29.1602 0Z",
    fill: "#D1EDF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1602 3.21094C36.6371 3.21112 42.6982 9.27301 42.6982 16.75C42.698 24.2268 36.6369 30.2879 29.1602 30.2881C21.6832 30.2881 15.6213 24.2269 15.6211 16.75C15.6211 9.2729 21.6831 3.21094 29.1602 3.21094ZM29.1592 7.64844C26.655 7.64862 24.625 9.67838 24.625 12.1826C24.6251 14.6868 26.655 16.7166 29.1592 16.7168C31.6635 16.7168 33.6943 14.6869 33.6943 12.1826C33.6943 9.67827 31.6635 7.64844 29.1592 7.64844Z",
    fill: "#307F92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1738 22.3115C22.1738 20.1024 23.9647 18.3115 26.1738 18.3115H32.1462C34.3554 18.3115 36.1462 20.1024 36.1462 22.3115V24.3845C36.1462 24.9368 35.6985 25.3845 35.1462 25.3845H23.1738C22.6215 25.3845 22.1738 24.9368 22.1738 24.3845V22.3115Z",
    fill: "#D1EDF2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1112,
    cy: 29.6517,
    r: 12.9022,
    fill: "#D1EDF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.11 22.9844C33.4289 22.9844 30.4449 25.9685 30.4449 29.6495C30.4449 33.3305 33.4289 36.3146 37.11 36.3146C40.791 36.3146 43.7751 33.3305 43.7751 29.6495C43.7751 25.9685 40.791 22.9844 37.11 22.9844ZM27.1123 29.6495C27.1123 24.128 31.5884 19.6519 37.11 19.6519C42.6315 19.6519 47.1076 24.128 47.1076 29.6495C47.1076 31.8087 46.4231 33.8081 45.2593 35.4424L53.2847 43.4678C53.9354 44.1185 53.9354 45.1735 53.2847 45.8242C52.6339 46.4749 51.5789 46.4749 50.9282 45.8242L42.9028 37.7988C41.2685 38.9627 39.2692 39.6472 37.11 39.6472C31.5884 39.6472 27.1123 35.1711 27.1123 29.6495Z",
    fill: "#307F92"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1112,
    cy: 29.6512,
    r: 6.66686,
    fill: "#D1EDF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSearchIcon);
export default __webpack_public_path__ + "static/media/candidate-search-icon.f3ce891d4cc2c52481aaa7219a2bc056.svg";
export { ForwardRef as ReactComponent };